import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "TlwJwg",
    defaultMessage: "Wholesale",
    description: "wholesale order settings section title",
  },
  description: {
    id: "OzHaVN",
    defaultMessage: "Configure pricing rules for wholesale orders.",
    description: "wholesale order settings section description",
  },
  singleItemMarkup: {
    id: "48WhK6",
    defaultMessage: "Single out-of-stock item markup (%)",
    description: "wholesale single out-of-stock item markup input label",
  },
  singleItemMarkupHelper: {
    id: "GgBvhR",
    defaultMessage:
      "Percentage added when a wholesale customer orders exactly one item that is out of stock.",
    description: "wholesale single out-of-stock item markup helper text",
  },
});
